import { FC, useEffect, useRef } from 'react';
import 'ol/ol.css';
import Map from 'ol/Map';
import View from 'ol/View';
import TileLayer from 'ol/layer/Tile';
import OSM from 'ol/source/OSM';
import VectorLayer from 'ol/layer/Vector';
import VectorSource from 'ol/source/Vector';
import Feature from 'ol/Feature';
import Point from 'ol/geom/Point';
import { fromLonLat } from 'ol/proj';
import Icon from 'ol/style/Icon';
import Style from 'ol/style/Style';

interface SimpleMapProps {
  lat: number;
  lon: number;
  className?: string;
}

const SimpleMap: FC<SimpleMapProps> = ({ lat, lon, className }) => {
  const mapRef = useRef<HTMLDivElement>(null);

  useEffect(() => {
    if (!mapRef.current) return;

    const newMap = new Map({
      target: mapRef.current,
      layers: [
        new TileLayer({
          source: new OSM(),
        }),
      ],
      view: new View({
        center: fromLonLat([lon, lat]),
        zoom: 16,
      }),
    });

    const markerLayer = new VectorLayer({
      source: new VectorSource({
        features: [
          new Feature({
            geometry: new Point(fromLonLat([lon, lat])),
          }),
        ],
      }),
      style: new Style({
        image: new Icon({
          anchor: [0.5, 1],
          src: 'https://cdn-icons-png.flaticon.com/32/684/684908.png',
        }),
      }),
    });

    newMap.addLayer(markerLayer);

    return () => newMap.setTarget(undefined);
  }, [lat, lon]);

  return (
    <div
      ref={mapRef}
      className={`h-full min-h-[300px] w-full overflow-hidden rounded-lg ${className || ''}`}
    />
  );
};

export { SimpleMap };
